import { Component } from "vue-property-decorator"

import SortByBase from "./sortBy.client.base"

@Component
export default class SortByWeb extends SortByBase {}
